// extracted by mini-css-extract-plugin
module.exports = {"SplashScreen":"SplashScreen_SplashScreen__2HbLt","entryLogo":"SplashScreen_entryLogo__HomR3","fadeOut":"SplashScreen_fadeOut__1u_dX"};